import React from "react";
import "../InvestmentPage/InvestmentSection.css";
import AboutImage from "../../Image/FPOImgae/AssestTaging.png";

export default function AssestSection() {
  return (
    <section className="fpo-excellence-section">
      <div className="fpo-excellence-container">

        {/* LEFT – IMAGE */}
        <div className="fpo-excellence-col fpo-excellence-left">
          <div className="fpo-excellence-image-wrapper">
            <img
              src={AboutImage}
              alt="Financial Process Outsourcing"
              className="fpo-excellence-img"
            />
          </div>
        </div>

        {/* RIGHT – CONTENT */}
        <div className="fpo-excellence-col fpo-excellence-right">
          <div className="fpo-excellence-content">

            <h2 className="fpo-excellence-title">
           Asset Tagging
            </h2>

            <p className="fpo-excellence-text">
             As per CARO (Companies Auditor’s Report Order) 2020, physical verification of fixed assets is the responsibility of management.

Asset tagging is the most important process to ensure all assets are physically verified and any movement in assets is known on a real time basis. This is also a very important process to ensure that any missing assets are immediately identified. Asset tagging helps in removing any possibility of siphoning off the assets or misappropriation of assets.
            </p>

            {/* SERVICES LIST */}
            <ul className="fpo-excellence-list">
            <br/>
            The practice of affixing tags or labels to assets in order to identify each one uniquely and monitor data ranging from its current location to its maintenance history is referred to as asset tagging. These tags are capable of being applied to movable as well as stationary assets that are dispersed over a number of locations and storage facilities, making it possible for enterprises to have a comprehensive view of their owned assets.

Asset-intensive companies have long recognised the need to implement a procedure that involves the use of digitised tracking technologies to monitor their assets. However, in order to have the capability to monitor assets, one must first begin the process of tagging such assets. The selection of appropriate tags to use for data collection pertaining to a company’s tangible assets is an essential component of the asset tagging process. Keep in mind that every tag is unique and has the potential to capture a separate set of data. 

            </ul>

          </div>

        </div>

      </div>
      <p>When mission-critical assets are tagged, crucial aspects such as these are ensured:
Safeguarding against theft
Regulation of stocks and supplies
Real-time monitoring and recording of data
There are various methods of assets tagging:-
RFID tags: RFID tags may be mounted to a number of surfaces and are available in a broad range of sizes and styles. RFID tags are also available in a variety of forms, including but not restricted to wet and dry inlays, wristbands, stickers, hard tags, cards, labels, and fobs. RFID tags from Densat are appropriate for a variety of contexts and applications, including logistics, race timing, supply chain,  laundry management, access control,  tool monitoring, and IT asset tracking.
GPS trackers: Global positioning system (GPS) tracking works by interacting with satellites to determine a precise location. They give precise position information in real time and are perfect for monitoring big, mobile assets, including equipment and vehicles. Although GPS devices are costly and not perfect for interior monitoring, they offer an efficient tracking option for a variety of applications, not limited to logistics, fleet management,  and transportation organizations.
NFC tags: RFID technology is subsumed by NFC (Near Field Communication). NFC tags, however, provide two-way communication, unlike RFID tags. enabling data transmission between electrical equipment and RFID tags. NFC tags are capable of storing up to 4 KB of data in many forms. NFC tags are useful for asset marking since they include unique identifying codes. Because NFC systems operate via cloud infrastructure, consumers may access data from anywhere.
Barcode and QR Code Labels: Businesses that keep thousands of assets in stock rooms find barcode asset tracking systems to be very popular due to their low prices and availability. Barcodes, which are composed of various bars and gaps representing distinct numbers and letters, may be read by simply scanning them with a suitable reader, such as a portable scanner or smartphone.
Densat is an industry leader in asset tagging and assists clients in the development of asset tagging policies. This ensures that customers get the finest and most appropriate technique that is specifically tailored to meet their needs.
</p>
    </section>
  );
}
